import router from './router'
import store from './store'
import {Message} from 'element-ui'
import {getToken} from '@/utils/auth' // get token from cookie
import Layout from '@/layout/index'
import Empty from '@/layout/empty'
let getRouter //用来获取后台拿到的路由

export const loadView = (file) => {
    if(typeof file === "string"){
        return (resolve) => require([`@/views/${file}/index`], resolve)
    }

}

//遍历后台传来的路由字符串，转换为组件对象
function filterAsyncRouter(asyncRouterMap) {
    const accessedRouters = asyncRouterMap.filter(route => {
        if (route.component) {
            if (route.component === 'Layout') {
                if(route.name == '企业监测') {
                    route.component = Empty
                } else{
                    route.component = Layout
                }
            } else {
                route.component = loadView(route.component)
            }

        }
        if (route.children && route.children.length) {
            route.children = filterAsyncRouter(route.children)
        }
        return true
    })

    return accessedRouters
}
//过滤路由
function routerGo(to, next) {
    getRouter = filterAsyncRouter(getRouter)
    router.addRoutes(getRouter)
    global.antRouter = getRouter
    next({ ...to, replace: true })
}


function getObjArr(name) {
    return JSON.parse(sessionStorage.getItem(name));

}

const whiteList = ['/login'] // no redirect whitelist


router.beforeEach(async (to, from, next) => {
    console.log(to,next)
    
    // determine whether the user has logged in
    const hasToken = getToken()
    if (hasToken) {
        if (to.path === '/login') {
            // if is logged in, redirect to the home page
            getRouter = null
            next({path: '/'})
        } else {
            const hasGetUserInfo = store.getters.name
            console.log('hasGetUserInfo',hasGetUserInfo)
            //console.log(hasGetUserInfo)
            if (hasGetUserInfo) {
                next()
            } else {
                try {
                    //console.log(getRouter)
                    await store.dispatch('user/getInfo')
                    if (!getRouter) { //不加这个判断，路由会陷入死循环
                        getRouter = getObjArr('router') //拿到路由
                        routerGo(to, next)
                    } else {
                        if(hasGetUserInfo){
                            getRouter = getObjArr('router') //拿到路由
                            routerGo(to, next)
                        }
                        next()
                    }
                } catch (error) {
                    getRouter = null
                    next(`/login`)
                }
            }
        }
    } else {
        /* has no token*/
        getRouter = null
        if (whiteList.indexOf(to.path) !== -1) {
            // in the free login whitelist, go directly
            next()
        } else {
            // other pages that do not have permission to access are redirected to the login page.

            next(`/login`)
        }
    }
})

router.afterEach(() => {
    // finish progress bar
})



// WEBPACK FOOTER //
// ./src/permission.js